import actionCreatorFactory from 'typescript-fsa'

import { GetHelpPostRequest, HelpPost } from '@professocialApi/professocial-core-frontend-api'
import {
  CreateEditorHelpPostRequest, DeleteEditorHelpPostRequest, GetEditorHelpPostRequest, UpdateEditorHelpPostRequest,
} from '@professocialApi/professocial-core-frontend-api/apis/EditorHelpRESTServiceApi'

const actionCreator = actionCreatorFactory('HELP')

/*
 * Actions
 */

export const getHelpPostListInitiated = actionCreator('GET_HELP_POST_LIST_INITIATED')
export const getHelpPostList = actionCreator.async<undefined, Array<HelpPost>>('GET_HELP_POST_LIST')

export const getHelpPostInitiated = actionCreator<GetHelpPostRequest>('GET_HELP_POST_INITIATED')
export const getHelpPost = actionCreator.async<GetHelpPostRequest, HelpPost>('GET_HELP_POST')

export const setHelpPost = actionCreator<HelpPost | undefined>('SET_HELP_POST')

export const createEditorHelpPostInitiated = actionCreator<CreateEditorHelpPostRequest>('CREATE_EDITOR_HELP_POST_INITIATED')
export const createEditorHelpPost = actionCreator.async<CreateEditorHelpPostRequest, HelpPost>('CREATE_EDITOR_HELP_POST')

export const deleteEditorHelpPostInitiated = actionCreator<DeleteEditorHelpPostRequest>('DELETE_EDITOR_HELP_POST_INITIATED')
export const deleteEditorHelpPost = actionCreator.async<DeleteEditorHelpPostRequest, undefined>('DELETE_EDITOR_HELP_POST')

export const getEditorHelpPostInitiated = actionCreator<GetEditorHelpPostRequest>('GET_EDITOR_HELP_POST_INITIATED')
export const getEditorHelpPost = actionCreator.async<GetEditorHelpPostRequest, HelpPost>('GET_EDITOR_HELP_POST')

export const updateEditorHelpPostInitiated = actionCreator<UpdateEditorHelpPostRequest>('UPDATE_EDITOR_HELP_POST_INITIATED')
export const updateEditorHelpPost = actionCreator.async<UpdateEditorHelpPostRequest, HelpPost>('UPDATE_EDITOR_HELP_POST')
